'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UNAVAILABLE_REASONS = undefined;

var _reactUtils = require('react-utils');

var UNAVAILABLE_REASONS = exports.UNAVAILABLE_REASONS = (0, _reactUtils.keyMirror)({
  ALL_DAY_EVENT: null,
  EVENT: null,
  BUFFER: null,
  MINIMUM_NOTICE: null,
  PAST: null,
  DATE_NOT_CONFIGURED: null,
  TIME_NOT_CONFIGURED: null
});


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/workspace/MeetingsUI/MeetingsLib/target/src/MeetingsLib/static-2.875/constants/enums.js
// module id = 70
// module chunks = 0